import React, { useState } from 'react';

import './Setup.scss';
import { BaseReact } from '../../base.model';
import { ProfileQL } from '../../models/Profile';
import FiscalpopDialog from './Setup.fiscalpop.dialog';

import SetupLogoUpload from './Setup.logoUpload';
import SetupRfcChange from './Setup.rfcChange';
import SetupLugarChange from './Setup.lugarChange';
import SetupUploadCert from './Setup.certUpload';
import SetupKeyUpload from './Setup.keyUpload';
import SetupGlobalBilling from './Setup.globalBilling';
import SetupDefaults from './Setup.defaults';
import SectionTitleBar from '../components/titlebar';
import SetupBillingLink from './Setup.billLink';
import SetupExcludeBusiness from './Setup.exludeBusiness';

interface SetupProps extends BaseReact {
    currentUser: ProfileQL;
}

function SetupFiscalPop({ history, location, currentUser }: SetupProps) {
    console.log('[SETUP] ', currentUser);


    const search = !location.search ? false : location.search.replace('?', '').split('&').reduce((p, c) => {
        const [key, value] = c.split('=');
        p[key] = value === 'true' ? true : (value === 'false' ? false : (value));
        return p;
    }, {} as { [key: string]: any });
    const [highlighted] = useState(!!search && search['showcerts']);

    return (
        <div id="SetupFiscalPop">
            <SectionTitleBar currentUser={currentUser} title="Configurar cliente de FiscalPOP" />
            {
                currentUser.fiscalpopProfile ?
                    <div className="setupContent">
                        <div className='logoRows'>
                            <div className='entryRow'>
                                <SetupRfcChange fiscalpopProfile={currentUser.fiscalpopProfile} />
                                <SetupLugarChange fiscalpopProfile={currentUser.fiscalpopProfile} />
                                <SetupDefaults amazonProfile={currentUser.amazonProfile} />
                            </div>
                            <SetupLogoUpload currentUser={currentUser} />
                        </div>
                        <SetupUploadCert highlight={highlighted} fiscalpopProfile={currentUser.fiscalpopProfile} fiscalpopProfileStatus={currentUser.fiscalpopProfileStatus} authToken={currentUser.amazonProfile.authToken} />
                        <SetupKeyUpload highlight={highlighted} fiscalpopProfile={currentUser.fiscalpopProfile} fiscalpopProfileStatus={currentUser.fiscalpopProfileStatus} authToken={currentUser.amazonProfile.authToken}/>
                        <SetupBillingLink amazonProfile={currentUser.amazonProfile} />
                        <SetupGlobalBilling amazonProfile={currentUser.amazonProfile} />
                        <SetupExcludeBusiness amazonProfile={currentUser.amazonProfile} />
                    </div>

                    : ''
            }
            <FiscalpopDialog modalIsOpen={!currentUser.fiscalpopProfile} />
        </div>
    )
}

export default SetupFiscalPop;